import PropTypes from 'prop-types';
import React from 'react';

import { largeUp, small } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const Overview = ({ label, name, compareAtPrice, isSalePdp }) => (
  <div className="Overview">
    {label && (
      <span className="Overview__label">
        {isSalePdp ? (
          <>
            {label} <span className="Overview__compare-at">{compareAtPrice}</span>
          </>
        ) : (
          I18n.localize(`product.edition.${label}`)
        )}
        :
      </span>
    )}
    {name && <span className="Overview__name">{name}</span>}
    <style jsx>
      {`
        .Overview {
          margin-bottom: ${Theme.get('spacing')}px;
          font-size: ${Theme.get('font-size-small-px')};
          line-height: 1.25;
          display: flex;
        }

        .Overview__label {
          margin-right: ${(Theme.get('spacing') * 2) / 3}px;
          text-transform: uppercase;
          font-weight: ${Theme.get('font-weight-semi-bold')};
          letter-spacing: ${Theme.get('letter-spacing-large-px')};
        }

        .Overview__compare-at {
          text-decoration: line-through;
          color: ${Theme.get('colors-discount-grey')};
        }

        .Overview__name {
          font-weight: ${Theme.get('font-weight-normal')};
          letter-spacing: ${Theme.get('letter-spacing-tight')};
        }

        @media ${small} {
          .Overview {
            font-size: ${Theme.get('font-size-small-px')};
            line-height: 1.25;
            display: flex;
          }
        }

        @media ${largeUp} {
          .Overview {
            margin-bottom: ${Theme.get('spacing-px')};
            text-align: left;
          }
        }
      `}
    </style>
  </div>
);

Overview.propTypes = {
  label: PropTypes.string.isRequired,
  isSalePdp: PropTypes.bool.isRequired,
  name: PropTypes.string,
  compareAtPrice: PropTypes.string,
};

Overview.defaultProps = {
  name: '',
  compareAtPrice: '',
};

export default Overview;
